// import { useState, useEffect } from "react"
// import { motion, AnimatePresence } from "framer-motion"
// import { Activity, TrendingUp, Zap, CheckCircle, Radio, MessageSquare, FileText, Flag } from "lucide-react"
// import RadarDisplay from "./RadarDisplay"
// import { useMutation } from "@tanstack/react-query"
// import { getSignals } from "../../services/signalService";
// import { message } from "antd"

// export default function CommandSystemCmp() {
//   const [logs, setLogs] = useState([])
//   const [liveSignals, setLiveSignals] = useState([])
//   const [selectedLog, setSelectedLog] = useState(null)
//   const [isLoading, setIsLoading] = useState(false)

//   const signalMutation = useMutation({
//     mutationFn: getSignals,
//     onSuccess: (response) => {
//       if (response?.data?.results) {
//         setLogs(response.data.results);
//         setIsLoading(false);
//       }
//     },
//     onError: (error) => {
//       message.error(error);
//       setIsLoading(false);
//     },
//   });
//   useEffect(() => {

//     const initialLiveSignals = [
//       { id: "1", type: "opportunity", message: 'Early-stage opportunity: "AI Security Trend"', icon: "🔵" },
//       { id: "2", type: "risk", message: 'High-risk alert: "Regulatory Warning - Finance"', icon: "🔴" },
//       { id: "3", type: "stable", message: 'Stable: "Customer Feedback Spike"', icon: "🟢" },
//     ]
//     setLiveSignals(initialLiveSignals)
//   }, []);

//   const getPriorityIcon = (score) => {
//   if (score >= 85) return '🔴 Critical';
//   if (score >= 70) return '🟠 High';
//   if (score >= 50) return '🟡 Medium';
//   return '🟢 Low';
// };

//   useEffect(() => {
//     setIsLoading(true)
//     signalMutation.mutate();
//     const interval = setInterval(() => {
//       signalMutation.mutate();
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []);
//   return (
//     <>
//       {isLoading ? (    <div className="w-full h-screen flex items-center justify-center bg-gray-100">
//       <div className="text-gray-600 font-mono text-lg">Loading...</div>
//     </div>) : (
//       <div className="w-full h-screen bg-transparent text-gray-800 font-mono overflow-hidden relative flex flex-col">
//         {/* ENGINE ACTIVE Badge */}
//         <motion.div
//           className="absolute top-4 right-4 z-50 bg-green-500/20 border border-green-500 px-3 py-1 rounded text-xs text-green-700"
//           animate={{ opacity: [0.5, 1, 0.5] }}
//           transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
//         >
//           <Radio className="inline w-3 h-3 mr-1" />
//           ENGINE ACTIVE
//         </motion.div>

//         <div className="grid grid-cols-12 h-full flex-1 min-h-0">
//           {/* Left Panel - Autonomous Response Stream */}
//           <div className="col-span-3 border-r border-gray-300 p-4 flex flex-col overflow-hidden bg-gray-50 radar-Guide-step-5">
//             <div className="mb-4 flex-shrink-0">
//               <h2 className="text-sm font-bold text-gray-700 mb-2 border-b border-gray-300 pb-1">
//                 AUTONOMOUS RESPONSE STREAM
//               </h2>
//             </div>
//             <div className="flex-1 overflow-hidden overflow-y-auto space-y-2">
//               <AnimatePresence>
//                 {logs?.map((log, index) => {
//                   const IconComponent =
//                     {
//                       MessageSquare,
//                       CheckCircle,
//                       FileText,
//                       Flag,
//                       Zap,
//                       TrendingUp,
//                       Activity,
//                     }[log.toolIcon] || Activity

//                   return (
//                     <motion.div
//                       key={log.id}
//                       initial={{ opacity: 0, x: -20 }}
//                       animate={{
//                         opacity: index < 50 ? 1 : 0,
//                         x: 0,
//                       }}
//                       exit={{ opacity: 0, x: -20 }}
//                       className="p-3 text-xs bg-gray-200 border-2 border-green-500 rounded-lg shadow-lg hover:shadow-xl transition-all cursor-pointer hover:bg-gray-100 hover:border-green-600"
//                       style={{
//                         boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3), 0 0 0 1px rgba(34, 197, 94, 0.4)",
//                       }}
//                       onClick={(e) => {
//                         setSelectedLog(log)
//                       }}
//                     >
//                       <div className="flex items-start gap-2 flex-wrap">
//                         <span className="text-gray-600 flex-shrink-0 font-semibold">[{log.timestamp?.split("T")[1]?.split(".")[0]}]</span>
//                         <div className="flex items-center gap-1 flex-shrink-0">
//                           <IconComponent
//                             className={`w-3 h-3 flex-shrink-0 ${log.signal_type.includes('Opportunity')
//                               ? "text-green-600"
//                               : log.signal_type.includes('Alert')
//                                 ? "text-yellow-600"
//                                 : "text-blue-600"
//                               }`}
//                           />
//                           <span className="w-[90%] truncate text-green-700 font-medium whitespace-normal overflow-hidden">
//                             {log.signal_type}
//                           </span>
//                         </div>
//                         <span className="text-green-600 flex-shrink-0">→</span>
//                         <span className="text-gray-700 break-words">
//                           {log.raw_signal}
//                         </span>
//                       </div>
//                     </motion.div>
//                   )
//                 })}
//               </AnimatePresence>
//             </div>
//           </div>

//           {/* Center - Radar Display */}
//           <div className="col-span-6 flex items-center justify-center p-4 bg-transparent radar-Guide-step-6">
//             <RadarDisplay logs={logs} />
//           </div>

//           {/* Right Panel - Impact & Metrics */}
//           <div className="col-span-3 border-l border-gray-300 p-4 flex flex-col overflow-hidden bg-gray-50">
//             <div className="mb-4 flex-shrink-0">
//               <h2 className="text-sm font-bold text-gray-700 mb-2 border-b border-gray-300 pb-1 pt-7">
//                 RISK/OPPORTUNITY IMPACT READOUT
//               </h2>
//             </div>
//             <div className="flex-1 overflow-y-auto space-y-4">
//               {/* Risks Resolved */}
//               <motion.div
//                 className="p-3 border border-green-400 rounded bg-green-50 flex-shrink-0"
//                 animate={{
//                   borderColor: ["rgba(34, 197, 94, 0.4)", "rgba(34, 197, 94, 0.8)", "rgba(34, 197, 94, 0.4)"],
//                   boxShadow: [
//                     "0 0 5px rgba(34, 197, 94, 0.3)",
//                     "0 0 15px rgba(34, 197, 94, 0.5)",
//                     "0 0 5px rgba(34, 197, 94, 0.3)",
//                   ],
//                 }}
//                 transition={{ duration: 3, repeat: Number.POSITIVE_INFINITY }}
//               >
//                 <div className="flex items-center gap-2 mb-2">
//                   <span className="text-green-600 text-lg">✅</span>
//                   <div className="text-xs text-gray-700 font-medium">Risks Resolved</div>
//                 </div>
//                 <div className="text-2xl font-bold text-green-600">3</div>
//                 <div className="flex gap-1 mt-2">
//                   {[1, 2, 3].map((i) => (
//                     <motion.div
//                       key={i}
//                       className="h-1 bg-green-500 rounded-full flex-1"
//                       initial={{ scaleX: 0 }}
//                       animate={{ scaleX: 1 }}
//                       transition={{ duration: 0.5, delay: i * 0.2 }}
//                     />
//                   ))}
//                 </div>
//               </motion.div>

//               {/* Forecast Value Protected */}
//               <motion.div
//                 className="p-3 border border-blue-400 rounded bg-blue-50 flex-shrink-0"
//                 animate={{
//                   borderColor: ["rgba(59, 130, 246, 0.4)", "rgba(59, 130, 246, 0.8)", "rgba(59, 130, 246, 0.4)"],
//                   boxShadow: [
//                     "0 0 5px rgba(59, 130, 246, 0.3)",
//                     "0 0 15px rgba(59, 130, 246, 0.5)",
//                     "0 0 5px rgba(59, 130, 246, 0.3)",
//                   ],
//                 }}
//                 transition={{ duration: 2.5, repeat: Number.POSITIVE_INFINITY }}
//               >
//                 <div className="flex items-center gap-2 mb-2">
//                   <span className="text-blue-600 text-lg">📈</span>
//                   <div className="text-xs text-gray-700 font-medium">Forecast Value Protected</div>
//                 </div>
//                 <div className="text-2xl font-bold text-blue-600">$28.9K</div>
//                 <div className="w-full bg-blue-200 rounded-full h-2 mt-2">
//                   <motion.div
//                     className="bg-gradient-to-r from-blue-500 to-blue-400 h-2 rounded-full"
//                     initial={{ width: 0 }}
//                     animate={{ width: "89%" }}
//                     transition={{ duration: 2, ease: "easeOut" }}
//                   />
//                 </div>
//               </motion.div>

//               {/* Strategic Confidence Score */}
//               <motion.div
//                 className="p-3 border border-green-400 rounded bg-green-50 flex-shrink-0"
//                 animate={{
//                   borderColor: ["rgba(34, 197, 94, 0.4)", "rgba(34, 197, 94, 0.9)", "rgba(34, 197, 94, 0.4)"],
//                   boxShadow: [
//                     "0 0 5px rgba(34, 197, 94, 0.3)",
//                     "0 0 20px rgba(34, 197, 94, 0.6)",
//                     "0 0 5px rgba(34, 197, 94, 0.3)",
//                   ],
//                 }}
//                 transition={{ duration: 4, repeat: Number.POSITIVE_INFINITY }}
//               >
//                 <div className="flex items-center gap-2 mb-2">
//                   <span className="text-green-600 text-lg">🎯</span>
//                   <div className="text-xs text-gray-700 font-medium">Strategic Confidence Score</div>
//                 </div>
//                 <div className="text-2xl font-bold text-green-600">92%</div>
//                 <div className="flex gap-1 mt-2">
//                   {Array.from({ length: 10 }, (_, i) => (
//                     <motion.div
//                       key={i}
//                       className={`h-2 rounded-full flex-1 ${i < 9 ? "bg-green-500" : "bg-gray-300"}`}
//                       initial={{ scaleY: 0 }}
//                       animate={{ scaleY: 1 }}
//                       transition={{ duration: 0.3, delay: i * 0.1 }}
//                     />
//                   ))}
//                 </div>
//               </motion.div>

//               {/* Response Time */}
//               <motion.div
//                 className="p-3 border border-yellow-400 rounded bg-yellow-50 flex-shrink-0"
//                 animate={{
//                   borderColor: ["rgba(234, 179, 8, 0.4)", "rgba(234, 179, 8, 0.8)", "rgba(234, 179, 8, 0.4)"],
//                   boxShadow: [
//                     "0 0 5px rgba(234, 179, 8, 0.3)",
//                     "0 0 15px rgba(234, 179, 8, 0.5)",
//                     "0 0 5px rgba(234, 179, 8, 0.3)",
//                   ],
//                 }}
//                 transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
//               >
//                 <div className="flex items-center gap-2 mb-2">
//                   <span className="text-yellow-600 text-lg">⚡</span>
//                   <div className="text-xs text-gray-700 font-medium">Response Time</div>
//                 </div>
//                 <div className="text-2xl font-bold text-yellow-600">8.2 sec</div>
//                 <div className="relative w-full bg-yellow-200 rounded-full h-2 mt-2">
//                   <motion.div
//                     className="bg-gradient-to-r from-yellow-500 to-yellow-400 h-2 rounded-full"
//                     initial={{ width: 0 }}
//                     animate={{ width: "35%" }}
//                     transition={{ duration: 1.5, ease: "easeOut" }}
//                   />
//                   <div className="absolute right-0 top-0 h-2 w-1 bg-green-500 rounded-full" />
//                 </div>
//               </motion.div>

//               {/* New Signal Types Detected */}
//               <motion.div
//                 className="p-3 border border-purple-400 rounded bg-purple-50 flex-shrink-0"
//                 animate={{
//                   borderColor: ["rgba(168, 85, 247, 0.4)", "rgba(168, 85, 247, 0.8)", "rgba(168, 85, 247, 0.4)"],
//                   boxShadow: [
//                     "0 0 5px rgba(168, 85, 247, 0.3)",
//                     "0 0 15px rgba(168, 85, 247, 0.5)",
//                     "0 0 5px rgba(168, 85, 247, 0.3)",
//                   ],
//                 }}
//                 transition={{ duration: 3.5, repeat: Number.POSITIVE_INFINITY }}
//               >
//                 <div className="flex items-center gap-2 mb-2">
//                   <span className="text-purple-600 text-lg">💡</span>
//                   <div className="text-xs text-gray-700 font-medium">New Signal Types Detected</div>
//                 </div>
//                 <div className="text-2xl font-bold text-purple-600">2</div>
//                 <div className="flex gap-2 mt-2">
//                   <motion.div
//                     className="w-3 h-3 bg-purple-500 rounded-full"
//                     animate={{
//                       scale: [1, 1.3, 1],
//                       opacity: [0.7, 1, 0.7],
//                     }}
//                     transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
//                   />
//                   <motion.div
//                     className="w-3 h-3 bg-purple-500 rounded-full"
//                     animate={{
//                       scale: [1, 1.3, 1],
//                       opacity: [0.7, 1, 0.7],
//                     }}
//                     transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, delay: 0.5 }}
//                   />
//                   <div className="w-3 h-3 bg-gray-300 rounded-full" />
//                 </div>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom Panel - Live Signal Feed */}
//         <div className="border-t border-gray-300 bg-gray-100 p-4 flex-shrink-0">
//           <h3 className="text-sm font-bold text-gray-700 mb-2">INCOMING SIGNALS</h3>
//           <div className="flex gap-6 overflow-x-auto">
//             {liveSignals.map((signal, index) => (
//               <motion.div
//                 key={signal.id}
//                 className={`flex items-center gap-2 text-xs whitespace-nowrap ${signal.type === "opportunity"
//                     ? "text-blue-600"
//                     : signal.type === "risk"
//                       ? "text-red-600"
//                       : "text-green-600"
//                   }`}
//                 animate={{ opacity: [0.6, 1, 0.6] }}
//                 transition={{
//                   duration: 3,
//                   repeat: Number.POSITIVE_INFINITY,
//                   delay: index * 0.5,
//                 }}
//               >
//                 <span className="text-lg">{signal.icon}</span>
//                 <span>{signal.message}</span>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* Modal */}
//         {selectedLog && (
//           <>
//             {/* Backdrop */}
//             <div className="fixed inset-0 bg-black/20 z-40" onClick={() => setSelectedLog(null)} />

//             {/* Modal */}
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9, x: -20 }}
//               animate={{ opacity: 1, scale: 1, x: 0 }}
//               exit={{ opacity: 0, scale: 0.9, x: -20 }}
//               className="fixed z-50 left-[38%] top-[30%] transform -translate-x-[38%] -translate-y-[30%] bg-white border-2 border-green-400 rounded-lg shadow-2xl p-6 min-w-[300px] max-w-[400px] overflow-hidden overflow-y-auto"
//               style={{
//                 boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(34, 197, 94, 0.3)",
//               }}
//             >
//               {/* Close button */}
//               <button
//                 onClick={() => setSelectedLog(null)}
//                 className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl font-bold"
//               >
//                 ×
//               </button>

//               {/* Modal content */}
//               <div className="space-y-4 overflow-hidden overflow-y-auto max-h-[60vh]">
//                 <div className="border-b border-gray-200 pb-3">
//                   <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
//                     {(() => {
//                       const IconComponent =
//                         {
//                           MessageSquare,
//                           CheckCircle,
//                           FileText,
//                           Flag,
//                           Zap,
//                           TrendingUp,
//                           Activity,
//                         }[selectedLog.toolIcon] || Activity
//                       return <IconComponent className="w-5 h-5 text-green-600" />
//                     })()}
//                     {selectedLog.tool} Details
//                   </h3>
//                 </div>

//                 <div className="space-y-3 text-sm">
//                   <div className="flex justify-between">
//                     <span className="text-gray-600 font-medium">Timestamp:</span>
//                     <span className="text-gray-800 font-mono">{selectedLog.timestamp}</span>
//                   </div>

//                   <div className="flex justify-between">
//                     <span className="text-gray-600 font-medium">Action:</span>
//                     <span className="text-gray-800">{selectedLog.action}</span>
//                   </div>

//                   <div className="flex justify-between">
//                     <span className="text-gray-600 font-medium">Status:</span>
//                     <span
//                       className={`px-2 py-1 rounded text-xs font-bold ${selectedLog.signal_type.includes("Opportunity")
//                         ? "bg-green-100 text-green-700"
//                         : selectedLog.signal_type.includes("Alert")
//                           ? "bg-yellow-100 text-yellow-700"
//                           : "bg-blue-100 text-blue-700"
//                         }`}
//                     >
//                       {selectedLog.signal_type?.toUpperCase()}
//                     </span>
//                   </div>

//                   <div>
//                     <span className="text-gray-600 font-medium">Description:</span>
//                     <p className="text-gray-800 mt-1">{selectedLog.enrichment}</p>
//                   </div>

//                   <div className="border-t border-gray-200 pt-3">
//                     <span className="text-gray-600 font-medium">Additional Info:</span>
//                     <div className="mt-2 space-y-1 text-xs">
//                       <div className="flex justify-between">
//                         <span>Priority Level:</span>
//                         <span className="font-medium">

//                           {getPriorityIcon(selectedLog.score)}
//                         </span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Auto-Response:</span>
//                         <span className="font-medium text-green-600">Enabled</span>
//                       </div>
//                       <div className="flex justify-between">
//                         <span>Impact Score:</span>
//                         <span className="font-medium">{selectedLog.score}/100</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </>
//         )}
//       </div>
//     )}
//     </>
//   )
// }

import { useState, useEffect, useCallback } from "react"
import { motion } from "framer-motion"
import { Radio } from "lucide-react"
import { useMutation } from "@tanstack/react-query"
import { message } from "antd"

import RadarPriorityControl from "./components/RadarPriorityControl"
import ConfidenceThreshold from "./components/ConfidenceThreshold"
import ExecutionThreshold from "./components/ExecutionThreshold"
import RecentAutoExecutions from "./components/RecentAutoExecutions"
import LiveRadarExecutionPanel from "./components/LiveRadarExecutionPanel"
import IncomingSignalFeed from "./components/IncomingSignalFeed"
import { getSignals } from '../../services/signalService'

export default function RadarPlusPage() {
  const [logs, setLogs] = useState([])
  const [selectedLog, setSelectedLog] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const [radarPriorities, setRadarPriorities] = useState([
    { group: "Growth & Revenue", metric: "Monthly Recurring Revenue (MRR)", colorClass: "#4DC98B" },
    { group: "Financial Efficiency", metric: "Burn Rate", colorClass: "#D83B5C" },
    { group: "Operational Health", metric: "Task Completion Rate", colorClass: "#FFB650" },
    { group: "Sales & Pipeline", metric: "Churn Rate (Customer/Revenue)", colorClass: "#4179D4" },
  ])

  const [confidenceThreshold, setConfidenceThreshold] = useState(0)
  const [executionScoreThreshold, setExecutionScoreThreshold] = useState(85)
  const [executionDelayBuffer, setExecutionDelayBuffer] = useState("1 day")

  const [liveExecutionSignals, setLiveExecutionSignals] = useState([])

  const mockRecentExecutions = [
    { id: 1, type: "Risk", description: "Burn Rate Surge", score: 89, action: "Auto-Reroute", time: "3m ago" },
    { id: 2, type: "Opp", description: "CAC Drop", score: 91, action: "Amplify Spend", time: "10m ago" },
    { id: 3, type: "Risk", description: "Margin Pressure", score: 83, action: "Freeze Ops", time: "25m ago" },
    { id: 4, type: "Opp", description: "New Lead Source", score: 94, action: "Scale Campaign", time: "1h ago" },
    {
      id: 5,
      type: "Risk",
      description: "Supply Chain Disruption",
      score: 88,
      action: "Diversify Suppliers",
      time: "2h ago",
    },
  ]

  const signalMutation = useMutation({
    mutationFn: getSignals,
    onSuccess: (response) => {
      if (response?.data?.results) {
        setLogs(response.data.results)
        setIsLoading(false)
      }
    },
    onError: (error) => {
      message.error(error.message || "Failed to fetch signals")
      setIsLoading(false)
    },
  })

  useEffect(() => {
    setIsLoading(true)
    signalMutation.mutate()
    const interval = setInterval(() => {
      signalMutation.mutate()
    }, 5000)

    return () => clearInterval(interval)
  }, [confidenceThreshold, executionScoreThreshold, executionDelayBuffer, radarPriorities, liveExecutionSignals]) 
  
  const handleAddLiveExecutionSignal = useCallback(
    (signalToAdd) => {
      setLiveExecutionSignals((prevSignals) => {
        if (!prevSignals.some((s) => s.id === signalToAdd.id)) {
          const enrichedSignal = {
            ...signalToAdd,
            confidence: signalToAdd.confidence || 1.0,
            category: signalToAdd.category || "General",
          }
          return [...prevSignals, enrichedSignal]
        }
        return prevSignals
      })
    },
    [radarPriorities],
  )

  const getPriorityIcon = (score) => {
    if (score >= 85) return "🔴 Critical"
    if (score >= 70) return "🟠 High"
    if (score >= 50) return "🟡 Medium"
    return "🟢 Low"
  }

  return (
    <div className="w-full bg-transparent overflow-hidden relative">
      {/* ENGINE ACTIVE Badge */}
      <motion.div
        className="absolute top-1 right-1 z-50 bg-green-500/20 border border-green-500 px-3 py-1 rounded text-xs text-green-700"
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
      >
        <Radio className="inline w-3 h-3 mr-1" />
        ENGINE ACTIVE
      </motion.div>

      <div className="w-full h-[80vh] flex overflow-hidden">
        <div className="w-[65%] p-4 flex flex-col gap-6 border-r border-gray-300 bg-gray-50 overflow-y-auto">
          <RadarPriorityControl priorities={radarPriorities} onPrioritiesChange={setRadarPriorities} />
          <ConfidenceThreshold threshold={confidenceThreshold} onThresholdChange={setConfidenceThreshold} />
          <ExecutionThreshold
            score={executionScoreThreshold}
            onScoreChange={setExecutionScoreThreshold}
            delay={executionDelayBuffer}
            onDelayChange={setExecutionDelayBuffer}
          />
          <RecentAutoExecutions recentExecutions={mockRecentExecutions} />
        </div>
        <div className="w-[35%] p-4 flex flex-col bg-gray-50 overflow-y-auto radar-Guide-step-6">
          <LiveRadarExecutionPanel
            isLoading={isLoading}
            logs={logs}
            radarPriorities={radarPriorities}
            confidenceThreshold={confidenceThreshold}
            executionScoreThreshold={executionScoreThreshold}
            executionDelayBuffer={executionDelayBuffer}
          />
        </div>
      </div>

      <IncomingSignalFeed logs={logs} />

      {selectedLog && (
        <>
          <div className="fixed inset-0 bg-black/20 z-40" onClick={() => setSelectedLog(null)} />

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="fixed inset-0 m-auto z-50 bg-white border-2 border-green-400 rounded-lg shadow-2xl p-6 max-w-md max-h-[80vh] overflow-hidden overflow-y-auto"
            style={{
              boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(34, 197, 94, 0.3)",
            }}
          >
            <button
              onClick={() => setSelectedLog(null)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl"
            >
              ×
            </button>
            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <h3 className="text-lg flex items-center gap-2">
                  Signal Details
                </h3>
              </div>

              <div className="space-y-3 text-sm">
                <div className="flex justify-between">
                  <span className="font-medium">Timestamp:</span>
                  <span>{selectedLog.timestamp}</span>
                </div>

                <div className="flex justify-between">
                  <span className=" font-medium">Action:</span>
                  <span>{selectedLog.decision}</span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Status:</span>
                  <span
                    className={`px-2 py-1 rounded text-xs ${selectedLog.signal_type.includes("Opportunity")
                      ? "bg-green-100 text-green-700"
                      : selectedLog.signal_type.includes("Risk")
                        ? "bg-red-100 text-red-700"
                        : "bg-blue-100 text-blue-700"
                      }`}
                  >
                    {selectedLog.signal_type?.replace(/\*\*/g, "").toUpperCase()}
                  </span>
                </div>

                <div>
                  <span className="font-medium">Description:</span>
                  <p className="mt-1">{selectedLog.enrichment}</p>
                </div>

                <div className="border-t border-gray-200 pt-3">
                  <span className="font-medium">Additional Info:</span>
                  <div className="mt-2 space-y-1 text-xs">
                    <div className="flex justify-between">
                      <span>Priority Level:</span>
                      <span className="font-medium">{getPriorityIcon(selectedLog.score)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Auto-Response:</span>
                      <span className="font-medium text-green-600">Enabled</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Impact Score:</span>
                      <span className="font-medium">{selectedLog.score}/100</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </div>
  )
}